import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrl: './camera.component.scss'
})

export class CameraComponent {

  @Input() picMetaData: any;
  @Output() getPicture = new EventEmitter<any>();
  isCameraExist :boolean = true
  showCamDialogue: boolean = true   //To set Cam dialogue show/Hide
  switchOnWebcam: boolean = true     //To set clicked pic view show/Hide
  webcamImage!: WebcamImage;
  cameraForTitle: any = ''
  errors: WebcamInitError[] = [];

  /**
   *  webcam snapshot trigger
   */
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  constructor() { }

  ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.isCameraExist = mediaDevices && mediaDevices?.length > 0;
      });
  }

  /**
   * Camera Pic click
   */
  takeSnapshot(): void {
    this.trigger?.next();
  }

  /**
   * switch camera onClick i.e on/off or vice versa
   */
  onOffWebCame() {
    this.switchOnWebcam = !this.switchOnWebcam;
  }

  /**
   *
   * @param webcamImage NGX Webcam Image Upload
   */
  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    this.switchOnWebcam = false;
  }


  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  /**
   * Images Pic Title & Set/Show Image
   */
  returnPic(){
    this.getPicture.emit(
      {
        "picTitle": this.picMetaData?.picTitle,
        "picFor": this.picMetaData?.picFor,
        "capturedPic": this.webcamImage,
      });
  }

  closeDialogue(){
    this.returnPic();
    this.isCameraExist = false
  }
}

